(function () {
  'use strict';

  angular
    .module('pairingCompliments')
    .config(config);

  function config($stateProvider) {
    $stateProvider
    .state('pairingCompliments', {
      sticky: true,
        url: '/pairing-compliments',
        views: {
            'pairingComplimentsView': {
            	  templateUrl: 'pairing-compliments/views/pairing-compliments.tpl.html',
                  controller: 'PairingComplimentsCtrl',
                  controllerAs: 'pairingCompliments'
            }
        }
    });
  }
}());


